import { render, staticRenderFns } from "./cup2.vue?vue&type=template&id=698b7c6c&scoped=true&"
import script from "./cup2.vue?vue&type=script&lang=js&"
export * from "./cup2.vue?vue&type=script&lang=js&"
import style0 from "./cup2.vue?vue&type=style&index=0&id=698b7c6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698b7c6c",
  null
  
)

export default component.exports